import React from "react";

import styled from "styled-components";
import { Colors } from "theme/colors";

import { ReactComponent as ChevronFillIcon } from "assets/icons/chevron-fill.svg";

interface Props {
  onClick?: () => void;
}

const Button = styled.button`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: ${Colors.neutral["04"]};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 500ms;

  &:hover {
    background-color: ${Colors.primary.blue};
  }

  &:active {
    background-color: ${Colors.blue["04"]};
  }
`;

const Icon = styled(ChevronFillIcon)`
  fill: currentColor;
  transform: rotate(-90deg);
`;

export const AccordionButton = ({ onClick }: Props): React.ReactElement => {
  return (
    <Button onClick={onClick}>
      <Icon />
    </Button>
  );
};
